import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Container, Row, Col, CardGroup, Card, CardBody, Button,
} from 'reactstrap';
import { getCompanyColors, getSigned } from '../../../utils/Api';
import css from '../../../containers/_Full/css';

const applyCSS = () => {
  function replaceAll(string, search, replace) {
    if (replace === undefined) {
      return string.toString();
    }
    return string.split(search).join(replace);
  }

  let companyColors = { primary_color: '55, 177, 174', secondary_color: '221, 236, 235' };
  let companyBg = '';
  const companyColorsPromise = getCompanyColors();
  companyColorsPromise.then((newCompanyColors) => {
    localStorage.setItem('colors', JSON.stringify(newCompanyColors.rgb));
    localStorage.setItem('bg', JSON.stringify(newCompanyColors.bg));
  }).then(() => {
    const localCompanyColors = localStorage.getItem('colors');
    const localCompanyBg = localStorage.getItem('bg');
    companyColors = (localCompanyColors === 'undefined' || !localCompanyColors)
      ? companyColors
      : JSON.parse(localCompanyColors);
    companyBg = (localCompanyBg === 'undefined' || !localCompanyBg)
      ? companyBg
      : JSON.parse(localCompanyBg);
  }).then(() => {
    let style = document.getElementById('company_colors');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('id', 'company_colors');
    }
    let rCSS = replaceAll(css, 'primary_color', companyColors.primary_color);
    rCSS = replaceAll(rCSS, 'secondary_color', companyColors.secondary_color);
    rCSS = replaceAll(rCSS, 'company_bg', companyBg);
    style.innerHTML = rCSS;
    document.head.appendChild(style);
  });
};

class Signed extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.getEmailSigned = this.getEmailSigned.bind(this);
  }

  componentDidMount() {
    applyCSS();
    this.getEmailSigned();
  }

  getEmailSigned() {
    const { intl, match } = this.props;
    const signedToken = match && match.params && match.params.signed_token;
    const getSignedPromise = getSigned(signedToken);
    getSignedPromise.then((result) => {
      if (result.signed) {
        this.setState({ signed: true });
      }
    });
  }

  render() {
    const { signed } = this.state;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1><FormattedMessage id="signed_title" /></h1>
                    {signed ?
                      (<React.Fragment>
                        <p className="text-muted"><FormattedMessage id="signed_successful" /></p>
                      </React.Fragment>) :
                      (<React.Fragment>
                        <p className="text-muted"><FormattedMessage id="signed_failed" /></p>
                      </React.Fragment>)
                    }
                    <p><Link to="/"><Button><FormattedMessage id="overall_input_continue" /></Button></Link></p>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Signed.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any),
};

export default injectIntl(Signed);



// WEBPACK FOOTER //
// ./src/views/Pages/_Signed/index.js